import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import SaltEditForm from './SaltEditForm';
import SaltList from './SaltList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import SaltListView from './SaltListView'


export default function SaltDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.saltDashboard);
  const [ saltId, setSaltId] = React.useState('');
  const [reloadSaltList, setReloadSaltList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <SaltEditForm 
            setReloadSaltList={setReloadSaltList}
            saltId={saltId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <SaltListView 
                      setSaltId = {setSaltId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
